import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTrackAgentChatThreadCreated } from '@air/analytics';
import { Canvases } from '@air/api';
import { callAirApi } from '@air/utils-api';
import { reportErrorToBugsnag } from '@air/utils-error';

import { PRIVATE_CANVAS_THREADS_LIST_KEY } from './usePrivateCanvasThreadsList';

export type UsePrivateCreateCanvasThreadMutationParams = NonNullable<Parameters<typeof Canvases.Threads.create>[0]>;

export const usePrivateCreateCanvasThreadMutation = () => {
  const queryClient = useQueryClient();
  const { trackAgentChatThreadCreated } = useTrackAgentChatThreadCreated();

  return useMutation({
    mutationFn: async (params: UsePrivateCreateCanvasThreadMutationParams) =>
      callAirApi(() => Canvases.Threads.create(params)),
    onError: (error) => {
      reportErrorToBugsnag({
        context: 'Failed to create canvas thread',
        error,
      });
    },
    onSuccess: (data, variables) => {
      trackAgentChatThreadCreated({ canvas_id: variables.canvasId, thread_id: data.id });
      queryClient.invalidateQueries({ queryKey: [PRIVATE_CANVAS_THREADS_LIST_KEY] });
    },
  });
};
